import React from "react";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 64, className }: LogoProps) {
  return (
    <img
      src="https://www.eigenify.com/images/eigenify-logo.png"
      alt="Eigenify"
      width={size}
      height={size}
      className={cn("dark:brightness-0 dark:invert transition-all", className)}
      style={{ height: size, width: "auto" }}
    />
  );
}






